import React from 'react';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import config from '../../config';
import Breadcrumbs from '../../components/Breadcrumb';
import MarkTopicAsReadButton from '../../components/MarkTopicAsReadButton';
import { FooterMobile } from '../../Layout/FooterMobile';
import { useChecklist } from '../../context/ChecklistContext';
import { getCurrentChecklistId } from '../../utils/checklistUtils';
import K5NavigateImg from '../../assets/images/siteImg/Image_GetComfortable.png';
import { useLinksContext } from '../../context/LinksContext';

const NavigatingOnlineSchool: React.FC = () => {
const { olsLink } = useLinksContext();

const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "School Prep Checklist", path: "/school-prep-checklist" },
    { label: "Online School", path: "/k12-checklist-category/online-school" },
    { label: "Navigating the Online School" }, 
];
// Get checklist data & currentChecklistId from ChecklistContext
const { checklistData } = useChecklist();
const currentChecklistId = getCurrentChecklistId(checklistData, "NAVIGATING_THE_ONLINE_SCHOOL");

const getOlsLink = () => {
    try {
        if (!olsLink) {
        console.warn("OLS link is missing.");
        return;
        }
        const cleanUrl = olsLink.trim().replace(/^"|"$/g, ""); 
        window.open(cleanUrl, "_blank");
    } catch (error) {
        console.error("Failed to open OLS link:", error);
    }
};

return (
    <div className="home-layout">
        <div className="sidebar-wrapper">
        <Sidebar />
        </div>
        <div className="body-wrapper-content">
        <div className="row">
            <div className="col-12">
                <Header />
                <div className="main-content">
                    <div className="row">
                        <div className="col-12">
                            <Breadcrumbs items={breadcrumbItems} />
                        </div>
                    </div>

                    <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-2 wp-block-columns-is-layout-flex">
                        <div
                        className="wp-block-column is-layout-flow wp-block-column-is-layout-flow"
                        style={{ flexBasis: "66.66%" }}
                        >
                        <div className="wp-block-k12-section container-fluid bg-transparent">
                            <div className="row">
                            <div className="col-12 g-0">
                                <h4 className="wp-block-heading">
                                The Online School (OLS) is where you will go to start the
                                school day. Learn what to look for and how to find everything
                                you need.&nbsp;&nbsp;
                                </h4>
                            </div>
                            </div>
                        </div>

                        <div className="wp-block-k12-section container-fluid bg-color-blue-t1-checklist">
                            <div className="row">
                            <div className="col-12 g-0">
                                <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                                <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                                    <figure className="wp-block-image size-full is-resized mw-100">
                                    <img
                                        decoding="async"
                                        src={K5NavigateImg}
                                        alt=""
                                        className="wp-image-896"
                                        style={{ width: "auto", height: "300px" }}
                                    />
                                    </figure>
                                </div>

                                <div className="wp-block-column p-5 is-layout-flow wp-block-column-is-layout-flow">
                                    <h2 className="wp-block-heading">
                                    <strong>Get Comfortable in the OLS</strong>
                                    </h2>
                                    <p>
                                    <strong>
                                        Take a little time to click through the OLS on your own
                                    </strong>
                                    , learning what’s available and where things are. Before
                                    school starts, you’ll gain access to more instruction for
                                    navigating courses.
                                    </p>
                                    <div className="wp-block-buttons is-layout-flex wp-block-buttons-is-layout-flex">
                                    <div className="wp-block-button btn-primary">
                                        <a
                                        className="wp-block-button__link wp-element-button"
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault(); 
                                            getOlsLink(); 
                                        }}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                        >
                                        Explore the OLS
                                        </a>

                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>

                        <div
                        className="wp-block-column is-layout-flow wp-block-column-is-layout-flow"
                        style={{ flexBasis: "33.33%" }}
                        ></div>
                    </div>
                    {/* Topic Read Component */}
                    {currentChecklistId && <MarkTopicAsReadButton checklistId={currentChecklistId} /> } 
                    
                </div>

            </div>
        </div>
        </div>
        <FooterMobile />
    </div>
);
};
export default NavigatingOnlineSchool;